import React from "react";
import Breadcrumbs from "../../CommonElements/Breadcrumbs";
import CalendarContain from "../../Component/Calendar/containers/CalendarContain";
import PageContainer from "../../Layout/Containers/PageContainer";

const Calendar = () => {
  return (
    <PageContainer
      breadcrumbs={<Breadcrumbs parent="Calendar" title="Kalender" />}
    >
      <CalendarContain />
    </PageContainer>
  );
};

export default Calendar;
